import React, { Component } from "react";
import { Button, Form, FormGroup, Label, Input, Col, Row, Alert } from 'reactstrap';
import BlockUi from 'react-block-ui';
import { reduxForm } from 'redux-form'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Messages from '../../notifications/Messages'
import Errors from '../../notifications/Errors'
import * as roleAction from './actions'
import * as roleConstant from './constants'
import { storedb } from '../../views/client/storedb'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import "react-tabs/style/react-tabs.css";
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import CheckboxTree from 'react-checkbox-tree';
import { BtnPermissions, BtnType } from '../../lib/BtnPermissions';
import { ButtonExt } from "../controls/ButtonExt"
import CheckboxTreeList from "../controls/_CheckboxTreeList";

class RoleEdit extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    roleUpdateRequest: PropTypes.func,
    roleDetailRequest: PropTypes.func,
    roleListRequest: PropTypes.func,
    menuListRequest: PropTypes.func,
    usersListRequest: PropTypes.func,
    roleEdit: PropTypes.shape({
      listRole: PropTypes.array,
      list: PropTypes.array,
      menuroles: PropTypes.array,
      item: PropTypes.object,
      type: PropTypes.string,
      listRequesting: PropTypes.bool,
      requesting: PropTypes.bool,
      successful: PropTypes.bool,
      messages: PropTypes.array,
      errors: PropTypes.array,
    }),
  }
  constructor(props) {
    super(props);
    var dbContext = storedb();
    this.state = {
      item: {
        Name: "",
        Status: -1,
        StoresId: dbContext.getStoreId(),
        Description: "",
        ParentId: 0
      },
      formError: {},
      formValid: false,
      stores_id: dbContext.getStoreId(),
      treeMenu: [],
      checked: [],
      expanded: [],
      treeNvkd: [],
      checkedNvkd: [],
      multipleValueNVKD: []
    };
  }
  getParam = (name) => {
    const queryParamsString = this.props.location.search.substring(1),
      searchParams = new URLSearchParams(queryParamsString);
    return searchParams.get(name);
  }
  handleControlChange = (e) => {
    let { item } = this.state
    item[e.target.name] = e.target.value
    this.setState({ item })
  }
  onHandleRemoveNvkd = () => {
    this.setState({ multipleValueNVKD: [] })
  }
  onHandleChoiceNvkd = (nodesChecked) => {
    var multipleValue = [];
    nodesChecked.forEach(function (item) {
      multipleValue.push(item.value);
    });
    this.setState({ multipleValueNVKD: multipleValue })
  }
  handleSelectChange = (name, selectedOption) => {
    let { item } = this.state;
    switch (name) {
      case "TrangThai":
        item.Status = selectedOption.target.value
        break;
      case "ParentRole":
        item.ParentId = selectedOption.target.value
        break;
      default:
        break;
    }
    this.setState({ item })
  }
  Cancel = () => {
    this.featchDetail();
  }
  buildTree = (arr, parentId = -1) => {
    var out = [];
    var parrent = [];
    if (arr.length > 0) {
      if (parentId == -1) {
        let menuIds = arr.map((menu) => {
          return menu.Id
        });
        parrent = arr.filter(f => !menuIds.includes(f.parent_id));
      }
      else {
        parrent = arr.filter(f => f.parent_id === parentId);
      }
      for (var i in parrent) {
        var tmp = new Object();
        tmp.value = parrent[i].Id;
        tmp.label = parrent[i].name;
        var children = this.buildTree(arr, parrent[i].Id)
        if (children.length) {
          tmp.children = children;
        }
        out.push(tmp)
      }
    }
    return out
  }
  featchDetail = () => {
    const { roleDetailRequest } = this.props
    let roleId = this.getParam("role");
    var requestData = {
      roleId: roleId,
      storeId: this.state.stores_id
    }
    return roleDetailRequest(requestData);
  }
  featchListRole = () => {
    const { roleListRequest } = this.props
    var requestData = {
      stores_id: this.state.stores_id,
      keyword: '',
      TrangThaiId: 1,
      page: this.state.page,
      per_page: this.state.per_page
    }
    return roleListRequest(requestData);
  }
  featchListMenu = () => {
    const { menuListRequest } = this.props
    let roleId = this.getParam("role");
    var requestData = {
      store_id: this.state.stores_id,
      roleId: roleId
    }
    return menuListRequest(requestData);
  }
  fetchNvkd = () => {
    const { usersListRequest } = this.props
    var requestData = {
      store_id: this.state.stores_id,
      is_only_inherit: true
    };
    return usersListRequest(requestData);
  }
  UpdateRole = () => {
    let formError = {};
    let formValid = true;
    if (!this.state.item.Name || this.state.item.Name == "") {
      formError.Name = 'Bạn chưa nhập tên nhón quyền';
    }
    if (this.state.item.Status == -1) {
      formError.Status = 'Bạn chưa nhập trạng thái';
    }
    for (var prp in formError) {
      if (prp && formError[prp] != '') {
        formValid = false;
        break;
      }
    }
    this.setState({ formError, formValid });
    if (formValid) {
      let { item } = this.state
      var requestData = {
        item: item,
        checked: this.state.checked,
        listNVKD: this.state.multipleValueNVKD,
      };
      this.props.roleUpdateRequest(requestData);
    }
  }
  BackToListRole = (item, e) => {
    this.props.history.push('/roles');
  }
  componentDidMount() {
    this.featchListRole();
    this.featchListMenu();
    this.fetchNvkd();
    this.featchDetail();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.roleEdit.type == roleConstant.MENU_LIST_SUCCESS) {
      let { list, menuroles } = nextProps.roleEdit;
      var checked = [];
      for (var i in menuroles) {
        checked.push(menuroles[i].MenuId)
      }
      this.setState({
        treeMenu: this.buildTree(list),
        checked
      });
    }
    else if (nextProps.roleEdit.type == roleConstant.ROLE_DETAIL_SUCCESS) {
      let { item, userMapping } = nextProps.roleEdit;
      if (item.RoleId && item.RoleId > 0) {
        var checkedNvkd = [];
        for (var i in userMapping) {
          checkedNvkd.push(userMapping[i].UserId)
        }
        this.setState({
          item: item,
          checkedNvkd
        });
      }
    }
    else if (nextProps.roleEdit.type == roleConstant.ROLE_UPDATE_SUCCESS) {
      this.props.history.push("/roles");
    }
    else if (nextProps.roleEdit.type == roleConstant.USERS_LIST_SUCCESS) {
      let { list } = nextProps.roleEdit;
      this.setState({
        treeNvkd: list
      });
    }
  }
  menuOnChecked = (checked, node) => {
    if (!node.checked && node.children && node.children.length > 0) {
      // neu uncheck thi kiem tra lại trong list có removed chưa
      const val = node.value + ''
      const index = checked.indexOf(val)
      if (index > -1) {
        checked.splice(index, 1)
      }
    }
    this.setState({ checked })
  }
  render() {
    const { formError, item, treeMenu, treeNvkd } = this.state;
    const {
      handleSubmit,
      roleEdit: {
        listRole,
        isRequesting,
        errors,
        messages
      },
    } = this.props
    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={false} >
          <Tabs>
            <TabList>
              <Tab>Thông tin</Tab>
              <Tab>Chức năng được xem</Tab>
            </TabList>
            <TabPanel>
              <div className="w-100 row">
                <div className="col-sm-6">
                  <Alert color="primary">Thông tin nhóm</Alert>
                  <Form>
                    <FormGroup>
                      <Label for="role">Tên nhóm</Label>
                      <Input type="text" name="Name" id="role" placeholder="Tên nhóm" value={item.Name || ''} onChange={this.handleControlChange.bind(this)} />
                      <em className="error invalid-feedback">{formError.Name}</em>
                    </FormGroup>
                    <FormGroup>
                      <Label for="statusSelect">Trạng thái</Label>
                      <select name="status" id="statusSelect" className="form-control" value={item.Status} onChange={this.handleSelectChange.bind(this, "TrangThai")}>
                        <option value={-1}>--Trạng thái--</option>
                        <option value={1}>Hoạt động</option>
                        <option value={0}>Ngừng hoạt động</option>
                      </select>
                      <em className="error invalid-feedback">{formError.Status}</em>
                    </FormGroup>
                    <FormGroup>
                      <Label for="descriptionText">Mô tả</Label>
                      <Input type="textarea" name="Description" className="form-control" value={item.Description || ''} id="descriptionText" onChange={this.handleControlChange.bind(this)} />
                    </FormGroup>
                  </Form>
                </div>
                <div className="col-sm-6">
                  <Alert color="success">Phân quyền dữ liệu</Alert>
                  <FormGroup>
                    <Label for="statusSelect">Cho phép nhóm xem doanh số của nhân viên không thuộc sự quản lý.  Ví dụ : Kế toán xem được hết đơn</Label>
                    <CheckboxTreeList
                      placeholder={`--Nhân viên KD--`}
                      nodes={treeNvkd}
                      checked={this.state.checkedNvkd}
                      isMultiChoice={true}
                      onHandleRemove={(item) => this.onHandleRemoveNvkd(item)}
                      onChoice={e => this.onHandleChoiceNvkd(e)}
                    />
                  </FormGroup>

                </div>
              </div>
            </TabPanel>
            <TabPanel>
              <CheckboxTree
                nodes={treeMenu}
                checked={this.state.checked}
                expanded={this.state.expanded}
                onCheck={(checked, node) => this.menuOnChecked(checked, node)}
                onExpand={expanded => this.setState({ expanded })}
              />
            </TabPanel>
          </Tabs>
          <div className="w-100 mb-2">
            {/* <Button size="md" color="success" className="mr-1" onClick={this.BackToListRole.bind(this, {})}><i className="fa fa-list"></i> Danh sách</Button> */}
            <ButtonExt btnClass="mr-1"
              color="success"
              iconClass="fa-list"
              displayText="Quay về"
              btnClick={() => this.BackToListRole()}
              permission={BtnPermissions.Role.LIST} />

            <ButtonExt btnClass="mr-1"
              color="primary"
              iconClass="fa-save"
              displayText="Lưu"
              btnClick={() => this.UpdateRole()}
              permission={BtnPermissions.Role.ADD_OR_UPDATE} />

            {/* <ButtonExt btnClass="mr-1"
              color="secondary"
              iconClass="fa-close"
              displayText="Hủy"
              btnClick={() => this.Cancel()}
              permission={""} /> */}
          </div>
        </BlockUi>
        <Row>
          <Col md="12">
            {!isRequesting && !!errors.length && (
              <Errors errors={errors} />
            )}
            {!isRequesting && !!messages.length && (
              <Messages messages={messages} />
            )}
          </Col>
        </Row>
      </div>
    )
  }
}
const mapStateToProps = state => ({
  roleEdit: state.roleEdit,
})
const connected = connect(mapStateToProps, {
  roleDetailRequest: roleAction.roleDetailRequest,
  roleUpdateRequest: roleAction.roleUpdateRequest,
  roleListRequest: roleAction.roleListRequest,
  menuListRequest: roleAction.menuListRequest,
  usersListRequest: roleAction.usersListRequest
})(RoleEdit)

const formed = reduxForm({
  form: 'roleEdit',
})(connected)

export default formed;


// WEBPACK FOOTER //
// ./src/views/Role/RoleEdit.js